import { type AppStyleSheet, setupStyleSheet } from "./setupStyleSheet"

export const changeTheme = (styleSheet: AppStyleSheet | null) => {

  if (styleSheet) {
    setupStyleSheet(styleSheet)
    return
  }
}

const colorToRgb = (color: string) => {
  let rgb: number[] = []

  if (color.startsWith("rgb")) {
    rgb = color.match(/\d+/g)?.map(Number) || []
  } else if (color.startsWith("#") && color.length == 4) {
    rgb = [
      parseInt(`${color[1]}${color[1]}`, 16),
      parseInt(`${color[2]}${color[2]}`, 16),
      parseInt(`${color[3]}${color[3]}`, 16),
    ]
  } else if (color.startsWith("#") && color.length == 7) {
    rgb = [
      parseInt(color.slice(1, 3), 16),
      parseInt(color.slice(3, 5), 16),
      parseInt(color.slice(5, 7), 16),
    ]
  }
  return rgb
}

const selectionHue = (color: string) => {
  const alpha = 0.05
  const rgb = colorToRgb(color)
  const [r, g, b] = rgb

  if (!rgb.length) {
    return "#FAFAFA"
  } else {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }
}

export const getContrastColor = (color: string) => {
  const [r, g, b] = colorToRgb(color)
  /* The actual YIQ color space average is calculated like so:
     ((r * 299) + (g * 587) + (b * 114)) / 1000
     We reduce the weight or r by half to achieve white text on orange backgrounds,
     see: https://uxmovement.com/buttons/the-myths-of-color-contrast-accessibility/
  */
  const yiq = (r * 150 + g * 587 + b * 114) / 1000

  return yiq >= 128 ? "black" : "white"
}

const hoverBrightness = (color: string) => {
  return getContrastColor(color) === "black" ? "92%" : "110%"
}

const maxBorderRadius = (remValue: string, max = 0.5) => {
  const value = parseFloat(remValue)
  if (isNaN(value)) {
    return remValue
  } else if (value > max) {
    return `${max}rem`
  } else {
    return `${value}rem`
  }
}
